

export const getImageSrc = (val) => {
    return window.REACT_APP_BASE_URL_FRONTEND ? `${window.REACT_APP_BASE_URL_FRONTEND}/v2/${val}` : process.env.BASE_URL_FRONTEND ? `${process.env.BASE_URL_FRONTEND}/v2/${val}` : val
  }
  